import actions from "./actions";

export default {
  namespaced: true,
  state: {
    genericSubdomains: ["app", "signup"],
  },
  mutations: {},
  actions,
};
